import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Rail, RailContainer } from 'components/Rail';
import { checkForPackage } from 'components/packages/getPackage';
import MidresponsiveAd from 'components/Ad/Midresponsive';
import * as CustomPropTypes from 'lib/CustomPropTypes';

import getPackagesForZone from '../getPackagesForZone';

import styles from './styles.module.scss';

function RightRail({ packages, zoneAFilled }, context) {
  const { isFirstRail, vertical } = context;
  const hasTitle = checkForPackage(packages, 'collectionTitle', 2);
  const isMSNBCAndHasTeaseList = checkForPackage(packages, 'teaseList', 2) && vertical === 'msnbc';

  const containerClasses = classNames(
    styles.rightRail,
    'layout-rightRail',
    {
      hasTitle,
      [styles.first]: isFirstRail,
      [styles.sub]: !isFirstRail,
    },
    'layout-grid-container',
  );
  const leftClasses = classNames(styles.left, 'layout-grid-item', {
    'grid-col-8-l grid-col-9-xl': isMSNBCAndHasTeaseList,
    'grid-col-7-l grid-col-8-xl': vertical === 'today',
    'grid-col-8-l': vertical !== 'today' && !isMSNBCAndHasTeaseList,
  });
  const rightClasses = classNames(styles.right, 'layout-grid-item', {
    'grid-col-4-l grid-col-3-xl': isMSNBCAndHasTeaseList,
    'grid-col-5-l grid-col-4-xl': vertical === 'today',
    'grid-col-4-l': vertical !== 'today',
    [styles.rightMsnbc]: !zoneAFilled,
  });

  return (
    <React.Fragment>
      <RailContainer className={containerClasses}>
        <div className={leftClasses}>
          {getPackagesForZone(1, packages, { ...context, isRailAdjacent: true })}
        </div>
        <Rail className={rightClasses}>
          {getPackagesForZone(2, packages, { ...context, railContext: 'right' })}
        </Rail>
      </RailContainer>

      {isFirstRail && <MidresponsiveAd />}
    </React.Fragment>
  );
}

RightRail.propTypes = {
  packages: PropTypes.arrayOf(CustomPropTypes.package).isRequired,
  zoneAFilled: PropTypes.number.isRequired,
};

RightRail.contextTypes = {
  ...CustomPropTypes.layoutContext,
  vertical: PropTypes.string,
};

export default RightRail;
